module.exports = __webpack_public_path__ + "static/media/carro_4.8c8e4da9.png";